import { render, staticRenderFns } from "./StorageChange.vue?vue&type=template&id=c1e90702&scoped=true&"
import script from "./StorageChange.vue?vue&type=script&lang=js&"
export * from "./StorageChange.vue?vue&type=script&lang=js&"
import style0 from "./StorageChange.vue?vue&type=style&index=0&id=c1e90702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e90702",
  null
  
)

export default component.exports